/**
 * DocsAfterDark — dark theme for Google Docs
 *
 * Declares a single web-accessible resource, `docs.bundle.css`, with no `use_dynamic_url`
 * but scoped via `matches` to docs.google.com only. The URL is fixed, making it a
 * conclusive probe — but the stylesheet is genuinely unreachable from any other origin,
 * so only Google Docs can detect this extension.
 *
 * From anywhere else a negative proves nothing, hence `requiredOrigin`.
 *
 * Manifest verified against version 2.0.2.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'pihphjfnfjmdbhakhjifipfdgbpenobg';

export const docsAfterDark: ExtensionDefinition = {
  id: ID,
  name: 'DocsAfterDark',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  requiredOrigin: 'https://docs.google.com',
  notes:
    'Its one WAR (docs.bundle.css) is scoped to docs.google.com with no dynamic URL, so ' +
    'only that origin can detect it — conclusive there, silent everywhere else.',
  signals: [
    {
      id: 'war-docs-bundle-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch docs.bundle.css — a fixed-URL stylesheet, but only exposed to docs.google.com.',
      weight: 1,
      run: () => probeFetch(ID, 'docs.bundle.css'),
    },
  ],
};
